import { render, staticRenderFns } from "./ConfirmSignUp.vue?vue&type=template&id=77c27951&scoped=true&"
import script from "./ConfirmSignUp.vue?vue&type=script&lang=js&"
export * from "./ConfirmSignUp.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmSignUp.vue?vue&type=style&index=0&id=77c27951&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c27951",
  null
  
)

export default component.exports